export default function StoreLocation() {
  return (
    <section id="contact" className="bg-black text-white py-16 px-6 md:px-20">

      <p className="text-green-400 text-center mb-2">Visit Our Store</p>

      <h2 className="text-2xl md:text-4xl font-bold text-center mb-12">
        Find Galaxy Super Market in Nashik
      </h2>

      <div className="grid md:grid-cols-2 gap-10">

        {/* Google Map */}
        <div className="w-full h-[400px] rounded-xl overflow-hidden">
          <iframe
            title="Galaxy Supermarket Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.3887647889005!2d73.75395177522768!3d19.950146381442895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdd95844a350a1b%3A0xf6eb7cdf9a500de5!2sGalaxy%20Supermarket.!5e0!3m2!1sen!2sin!4v1773874341437!5m2!1sen!2sin"
            className="w-full h-[400px] rounded-xl border-0"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="grid gap-4">

          <img
            src="/store2.jpg"
            alt="Store"
            className="rounded-xl object-cover h-60 w-full"
          />

        </div>

      </div>

    </section>
  );
}